import { Component, Injector, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { AppComponentBase } from '../../../../../shared/common/app-component-base';
import { ProjectDetailsDto, ProjectServiceProxy } from '../../../../../shared/service-proxies/service-proxies';
import { AppRoutes } from '@app/shared/routes/app-routes';
@Component({
    standalone: false,
    selector: 'app-dashboard-project-section',
    templateUrl: './dashboard-project-section.component.html',
    styleUrls: ['./dashboard-project-section.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class DashboardProjectSectionComponent extends AppComponentBase implements OnInit {
    constructor(private router: Router, private _projectServiceProxy: ProjectServiceProxy, injector: Injector) {
        super(injector);
    }
    Loaded = false;
    Empty = true;
    projectDetails: ProjectDetailsDto[];
    myProfileData: string;
    isEmployee: boolean = false;
    ngOnInit(): void {
        this.getUserProjectdetails();
    }
    getUserProjectdetails() {
        this._projectServiceProxy.getUserWiseProjectDetails(5).subscribe(result => {
            this.projectDetails = [];
            result.forEach(x => {
                this.projectDetails.push(x);
                this.Empty = false;
            });
            this.Loaded = true;
            this.markForCheck();
        });
    }
    viewall() {
        this.router.navigate([AppRoutes.projects]);
    }
    //project progressbar calculation
    HoursLoggedBarCalculation(startD: Date, endD: Date) {
        if (!startD || !endD)
            return 0;
        let progressBar = 0;
        var startDate = new Date(startD.toString());
        var endDate = new Date(endD.toString());
        const PresentDay = new Date();
        if ((startDate > endDate) || (startDate > PresentDay)) {
            progressBar = 0;
        }
        else if (PresentDay > endDate) {
            progressBar = 100;
        }
        else {
            progressBar = (PresentDay.getTime() - startDate.getTime()) * 100 / (endDate.getTime() - startDate.getTime());
        }
        progressBar = Math.floor(progressBar);
        return progressBar;
    }
}
